import { InjectionToken } from '@angular/core';

export const BUILD_CONFIG = new InjectionToken<BaseBuildConfig>('BUILD_CONFIG');
